import { Double, Identifiers, Long, Properties } from "../model/model"
import UserEvent from "./UserEvent"

export interface EventPayloadDto {
  exposureEvents: ExposureEventDto[]
  trackEvents: TrackEventDto[]
  remoteConfigEvents: RemoteConfigEventDto[]
}

export interface EventDto {
  insertId: string
  timestamp: Long

  userId?: string
  identifiers: Identifiers
  userProperties: Properties
  hackleProperties: Properties
  /** Optional so events persisted by older SDK versions remain dispatchable. */
  internalProperties?: Properties
}

export interface ExposureEventDto extends EventDto {
  experimentId: Long
  experimentKey: Long
  experimentType: string
  experimentVersion: Long
  variationId?: Long
  variationKey: string
  decisionReason: string
  properties: Properties
}

export interface TrackEventDto extends EventDto {
  eventTypeId: Long
  eventTypeKey: string
  value: Double
  properties: Properties
}

export interface RemoteConfigEventDto extends EventDto {
  parameterId: Long
  parameterKey: string
  parameterType: string
  decisionReason: string
  valueId?: Long
  properties: Properties
}

export function toPayload(events: Array<UserEvent | EventDto>): EventPayloadDto {
  const exposures = new Array<ExposureEventDto>()
  const tracks = new Array<TrackEventDto>()
  const remoteConfigs = new Array<RemoteConfigEventDto>()

  events.forEach((event) => {
    if (event instanceof UserEvent) {
      if (UserEvent.isExposureEvent(event)) {
        exposures.push(event.toDto())
      } else if (UserEvent.isTrackEvent(event)) {
        tracks.push(event.toDto())
      } else if (UserEvent.isRemoteConfigEvent(event)) {
        remoteConfigs.push(event.toDto())
      }
    } else {
      if (UserEvent.isExposureEventDto(event)) {
        exposures.push(event)
      } else if (UserEvent.isTrackEventDto(event)) {
        tracks.push(event)
      } else if (UserEvent.isRemoteConfigEventDto(event)) {
        remoteConfigs.push(event)
      }
    }
  })

  return {
    exposureEvents: exposures,
    trackEvents: tracks,
    remoteConfigEvents: remoteConfigs
  }
}
